import { Component, OnDestroy, OnInit } from '@angular/core';
import { StudyEntryService } from '../../../../shared/study/service/study-entry.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ParamContext } from '../../../../shared/service/param.context';
import { Subscription } from 'rxjs';
import { JhiEventManager } from '../../../../shared/core-utils';
import { AlertService } from '../../../../shared/alert/alert.service';
import { StudyEditorContext } from '../../../study-editor.context';
import { TranslateService } from '@ngx-translate/core';
import { ModalConfirmComponent } from '../../../../shared/modal/modal-confirm.component';

@Component({
    selector: 'jhi-add-new-entries',
    templateUrl: './add-new-entries.component.html',
    styleUrl: './add-new-entries.component.scss'
})
export class AddNewEntriesComponent implements OnInit, OnDestroy {

    entryTypes: any[] = [];
    selectedEntryTypeId: number;
    selectedGids: number[];
    germplasmSelectorEventSubscriber: Subscription;

    constructor(private eventManager: JhiEventManager,
                private router: Router,
                private paramContext: ParamContext,
                private studyEditorContex: StudyEditorContext,
                private studyEntryService: StudyEntryService,
                private translateService: TranslateService,
                private activeModal: NgbActiveModal,
                private modalService: NgbModal,
                private alertService: AlertService
    ) { }

    ngOnInit(): void {
        this.studyEntryService.getEntryTypes().toPromise().then(entryTypes => {
            this.entryTypes = entryTypes;
            this.selectedEntryTypeId = this.entryTypes[0].id;
        });
    }

    dismiss() {
        this.activeModal.dismiss();
    }

    addNewEntries() {

        const studyId = this.studyEditorContex.studyDetails.id;

        if (this.validateSelectedGIDs()) {
            this.studyEntryService.getAllStudyEntries(studyId, null).toPromise().then((studyEntries) => {
                const gids = [];
                studyEntries.forEach((studyEntry)=> {
                    gids.push(String(studyEntry.gid));
                });
                const existingGids = this.selectedGids.filter( (gid) => {
                    return gids.includes(String(gid));
                });
                if (existingGids.length === 0) {
                    this.proceedWithAddingNewEntries();
                } else {
                    const message = this.translateService.instant('study-editor.germplasm-checks.add.new.entries.existing.gids', { param: existingGids.join(', ') });

                    const modalRef = this.modalService.open(ModalConfirmComponent);
                    modalRef.componentInstance.message = message;
                    modalRef.result
                        .then(() => {
                            this.proceedWithAddingNewEntries();
                        });
                }
            });
        }
    }

    proceedWithAddingNewEntries() {
        const studyId = this.studyEditorContex.studyDetails.id;

        this.studyEntryService.saveStudyEntries(studyId ,this.selectedEntryTypeId, this.selectedGids).toPromise().then(() => {
            this.alertService.success('study-editor.germplasm-checks.add.new.entries.successful');
            this.activeModal.close();
        });
    }

    cancel() {
        this.activeModal.dismiss();
    }

    openSelectGermplasmForAddingEntries() {
        this.openGermplasmSelector(true);
    }

    openGermplasmSelector(selectMultiple: boolean): void {
        this.registerGermplasmSelectorSelected();
        this.router.navigate(['/', { outlets: { popup: 'germplasm-selector-dialog' } }], {
            queryParamsHandling: 'merge',
            queryParams: {
                cropName: this.paramContext.cropName,
                loggedInUserId: this.paramContext.loggedInUserId,
                programUUID: this.paramContext.programUUID,
                selectMultiple
            }
        });
    }

    validateSelectedGIDs() {
        let selectedGidsString = String(this.selectedGids).replace('[', '').replace(']', '');
        //remove whiteSpace
        selectedGidsString = selectedGidsString.split(/\s/).join('');

        const regex = /[0-9]+(,[0-9]+)*/g;
        if (regex.test(selectedGidsString)) {
            const selectedGidArray: number[] = selectedGidsString.split(',').map(Number);
            this.selectedGids = [];
            selectedGidArray.forEach((value) => {
                this.selectedGids.push(value);
            });
            return true;
        } else {
            this.alertService.error('study-editor.germplasm-checks.add.new.entries.gids.error');
            return false;
        }
    }

    registerGermplasmSelectorSelected() {
        this.germplasmSelectorEventSubscriber = this.eventManager.subscribe('germplasmSelectorSelected', (event) => {
            if (event.content) {
                this.selectedGids = event.content.split(',');
                if (this.germplasmSelectorEventSubscriber) {
                    this.eventManager.destroy(this.germplasmSelectorEventSubscriber);
                }
            }
        });
    }

    ngOnDestroy(): void {
        if (this.germplasmSelectorEventSubscriber) {
            this.eventManager.destroy(this.germplasmSelectorEventSubscriber);
        }
    }
}
